import styled from 'styled-components';

export const Container = styled.div`
  .ant-badge-count {
    background-color: #239687;
  }

  .ant-badge-multiple-words {
    padding: 0 4px;
  }
`;
